// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__G34gD","fileDisabled":"File_fileDisabled__2b_In"};